/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamViewEventBody
 */
export interface StreamViewEventBody {
    /**
     * start opens a view (needs platform and channelId), heartbeat accrues watch-time (needs viewId), end closes it (needs viewId)
     * @type {string}
     * @memberof StreamViewEventBody
     */
    action: StreamViewEventBodyActionEnum;
    /**
     * Required for action "start"
     * @type {string}
     * @memberof StreamViewEventBody
     */
    platform?: StreamViewEventBodyPlatformEnum;
    /**
     * Platform-specific channel identifier — required for action "start"
     * @type {string}
     * @memberof StreamViewEventBody
     */
    channelId?: string;
    /**
     * Required for action "end" — the StreamView ID returned by "start"
     * @type {string}
     * @memberof StreamViewEventBody
     */
    viewId?: string;
    /**
     * Hub context (optional)
     * @type {string}
     * @memberof StreamViewEventBody
     */
    surfaceId?: string;
    /**
     * Competition context (optional)
     * @type {string}
     * @memberof StreamViewEventBody
     */
    competitionId?: string;
}


/**
 * @export
 */
export const StreamViewEventBodyActionEnum = {
    start: 'start',
    heartbeat: 'heartbeat',
    end: 'end'
} as const;
export type StreamViewEventBodyActionEnum = typeof StreamViewEventBodyActionEnum[keyof typeof StreamViewEventBodyActionEnum];

/**
 * @export
 */
export const StreamViewEventBodyPlatformEnum = {
    TWITCH: 'TWITCH',
    YOUTUBE: 'YOUTUBE',
    KICK: 'KICK'
} as const;
export type StreamViewEventBodyPlatformEnum = typeof StreamViewEventBodyPlatformEnum[keyof typeof StreamViewEventBodyPlatformEnum];


/**
 * Check if a given object implements the StreamViewEventBody interface.
 */
export function instanceOfStreamViewEventBody(value: object): value is StreamViewEventBody {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function StreamViewEventBodyFromJSON(json: any): StreamViewEventBody {
    return StreamViewEventBodyFromJSONTyped(json, false);
}

export function StreamViewEventBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamViewEventBody {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'platform': json['platform'] == null ? undefined : json['platform'],
        'channelId': json['channelId'] == null ? undefined : json['channelId'],
        'viewId': json['viewId'] == null ? undefined : json['viewId'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
    };
}

export function StreamViewEventBodyToJSON(json: any): StreamViewEventBody {
    return StreamViewEventBodyToJSONTyped(json, false);
}

export function StreamViewEventBodyToJSONTyped(value?: StreamViewEventBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'platform': value['platform'],
        'channelId': value['channelId'],
        'viewId': value['viewId'],
        'surfaceId': value['surfaceId'],
        'competitionId': value['competitionId'],
    };
}

